module.exports = require("nanoid");